var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0025 0C9.5025 0 9.0025 0.19 8.5925 0.59L0.5925 8.59C-0.1975 9.37 -0.1975 10.63 0.5925 11.41L8.5925 19.41C9.3725 20.2 10.6325 20.2 11.4125 19.41L19.4125 11.41C20.2025 10.63 20.2025 9.37 19.4125 8.59L11.4125 0.59C11.0025 0.19 10.5025 0 10.0025 0ZM10.0025 4.95C12.7025 5.06 13.8725 7.78 12.2825 9.81C11.8625 10.31 11.1925 10.64 10.8525 11.07C10.5025 11.5 10.5025 12 10.5025 12.5H9.0025C9.0025 11.65 9.0025 10.94 9.3525 10.44C9.6825 9.94 10.3525 9.64 10.7725 9.31C12.0025 8.18 11.6825 6.59 10.0025 6.46C9.1825 6.46 8.5025 7.13 8.5025 7.97H7.0025C7.0025 6.3 8.3525 4.95 10.0025 4.95ZM9.0025 13.5H10.5025V15H9.0025V13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector-7.28ed5d854f8622ac4528094c9474e422.svg";
export { ForwardRef as ReactComponent };